// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React from 'react';
import './styles.scss';
import { dotted } from '../../../../assets/imgs';

function TopHeader(props) {
  return (
    <>
      <div className="top-header">
        <div className={`title AOTFShinMaruGoPro ${props.screen ? props.screen : ''}`}>
          {props.title}
        </div>
      </div>
      <div
        className="border-dots border-header"
        style={
          props.show && props.show === 'false'
            ? {
                opacity: '0',
                height: '1vw',
                marginBottom: '80px',
                marginTop: '2px',
              }
            : {
                backgroundImage: `url(${dotted})`,
                backgroundSize: '1200px',
                backgroundRepeatY: 'no-repeat',
                height: '10px',
                marginBottom: '80px',
                marginTop: '4px',
              }
        }
      ></div>
    </>
  );
}

export default TopHeader;
